import { ReactNode } from "react";
import Sidenav, { navWidth } from "commons/Sidenav";
import Header from "commons/Header";
import styles from "styles/UserHeader.module.css";
import { routesHelper } from "routes/routesHelper";
const railyLogo = require("assets/marketplace_logo.png");
const railyLogoSmall = require("assets/marketplace_logo_small.png");

export default function AuditorManagerView(props: { children?: ReactNode }) {
    return (
        <>
            <Sidenav
                items={routesHelper.getAuditorManagerRoutes().map((item) => {
                    return { url: item.path, icon: item.icon, name: item.name };
                })}
            />
            <div style={{ paddingLeft: navWidth }}>
                <Header>
                    <div className={styles.logo_wrapper}>
                        <picture>
                            <source media="(max-width: 700px)" srcSet={railyLogoSmall} />
                            <source srcSet={railyLogo} />
                            <img className={styles.logo} src={railyLogo} alt="Logo" />
                        </picture>
                    </div>
                </Header>

                {props.children}
            </div>
        </>
    );
}
